import api from "./baseApi";
import endpoints from "./endpoints";

export const getLogs = async ({ page = 1, perPage = 10 } = {}) => {
  try {
    const res = await api.get(endpoints.log.base, {
      params: { page, perPage },
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch logs";

    throw new Error(message);
  }
};